var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0052FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 21.3335C13.0678 21.3335 10.6767 18.9468 10.6767 16.0002C10.6767 13.0535 13.0678 10.6668 16.02 10.6668C18.665 10.6668 20.8602 12.5913 21.2832 15.1113H26.6666C26.2125 9.63572 21.6216 5.3335 16.02 5.3335C10.1201 5.3335 5.33331 10.1113 5.33331 16.0002C5.33331 21.889 10.1201 26.6668 16.02 26.6668C21.6216 26.6668 26.2125 22.3646 26.6666 16.8891H21.2788C20.8558 19.4091 18.665 21.3335 16.02 21.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseIcon);
export default __webpack_public_path__ + "static/media/Coinbase-icon.0bc0546b1cd3779384c316a9b650afa0.svg";
export { ForwardRef as ReactComponent };